import React, { useEffect, useState } from 'react';
import { createGroupAPI, getGroupsAPI, addPractitionersAPI } from '../../../api/protocolGroups';
import { ModalSpinner } from '../../../components/Utils/Loaders';
import GroupDetailContainer from './GroupDetailContainer';
import GroupListContainer from './GroupListContainer';
import Group from '../../../components/Protocols/Groups/Group';
import Card from '../../../components/Cards/Card';
import { HandleError } from '../../../components/Notifications/APIErrorHandler';
import { Success } from '../../../components/Notifications/Notifications';
import { useTranslation } from "react-i18next";
import CreateGroup from '../../../components/Protocols/Groups/CreateGroup.jsx';
import EditGroup from '../../../components/Protocols/Groups/ModalEditGroup.jsx';
import { useGroups, useGroupPractitioners, useGroupPatients, useGroupPatientsPractitioner } from './useGroups';
import DuplicateGroup from '../../../components/Protocols/Groups/DuplicateGroup.js';
import { ProtocolPicker } from '../../../components/CustomControls/ProtocolPicker';
import { Col, Row } from 'react-bootstrap';
import { CustomSelect } from '../../../components/CustomControls/CustomSelect';
import { SnomedPicker } from '../../../components/CustomControls/SnomedPicker';
import { snomedExpressions } from '../../../variables/Enums';
import { PractitionerPicker } from '../../../components/CustomControls/PractitionerPicker';

const GroupsContainer = () => {
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  //const [editGroup, setEditGroup] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingGroups, setIsLoadingGroups] = useState(true);

    const [, , editGroup] = useGroups();

    const { t } = useTranslation();
    const [protocolId, setProtocolId] = useState(null);

    const [query, setQuery] = useState({
        pagination: {
            page: 1,
            sizePerPage: 50,
            totalSize: 0
        },
        sort: {
            sortField: "Start",
            sortOrder: "desc"
        },
        filters: {
            protocolIds: null,
            specialtyId: null,
            practitionerId: null,
        }
    });

    useEffect(() => {
        setGroups([])
        setIsLoadingGroups(true);
        const fetchData = async () => {

            try {
                const response = await getGroupsAPI(query);
                const refreshedGroups = response.data?.data || [];

                setGroups(refreshedGroups);

                if (selectedGroup) {
                    const refreshedGroup = refreshedGroups.find(g => g.id === selectedGroup.id);
                    setSelectedGroup(refreshedGroup);
                }

            } catch (error) {
                console.log(error)

            } finally {
                setIsLoadingGroups(false);
            }
        };
        
        fetchData();
        
    }, [query]);

  //#region Handlers
    const handleCreateGroup = async (groupData) => {
        //setIsLoading(true);
        //setGroups([...groups, groupData]);
        createGroup(groupData)
            .then(() => {
                handleUpdateGroup()
                Success(t('protocols.groups.createdGroup'))
                //setIsLoading(false);
            })
            .catch(err => {
                console.error("Error creando grupo:", err);
                console.log(err.response.data)

                if (err?.response?.data?.Message) {
                    HandleError(err.response.data.Message);
                } else {
                    HandleError("Error creando grupo.");
                }
                //setIsLoading(false);
            });


    };

    const createGroup = async (groupData) => {

        //setIsLoading(true);

        return await createGroupAPI(groupData)
    }

    const handleEditGroup = async (groupId, groupData) => {

        editGroup(groupId, groupData)
            .then(() => {
                handleUpdateGroup()
                Success(t('protocols.groups.updatedGroup'))
            })
            .catch(err => {
                console.error("Error actualizando grupo:", err);
                console.log(err.response.data)

                if (err?.response?.data?.Message) {
                    HandleError(err.response.data.Message);
                } else {
                    HandleError("Error actualizando grupo.");
                }
            });
    }
    
    const handleUpdateGroup = async () => {

        try {
            setIsLoading(true);

            const response = await getGroupsAPI(query);
            const refreshedGroups = response.data?.data || [];

            setGroups(refreshedGroups);

            if (selectedGroup) {
                const refreshedGroup = refreshedGroups.find(g => g.id === selectedGroup.id);
                setSelectedGroup(refreshedGroup);
            }
        } catch (error) {
            console.error("Error al refrescar el grupo:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleFilterChange = (name, value) => {
        if (value) {
            if (name === "protocolIds") {
                setProtocolId(value[0].id.toString());
                onChangeFilter(name, value[0].id.toString());
            }
            if (name === "specialtyId") {
                onChangeFilter(name, value.conceptId);
            }
            if (name === "practitionerId") {               
                onChangeFilter(name, value[0].userId);
            }
        }
        else {            
            if (name === "protocolIds") {
                onChangeFilter(name, null);
                setProtocolId(null);
            }
            if (name === "specialtyId") {
                onChangeFilter(name, null);
            }
            if (name === "practitionerId") {
                onChangeFilter(name, null);
            }
        }
    }


    const onChangeFilter = (filterName, selectedValue) => {

        var newQuery = JSON.parse(JSON.stringify(query));

        newQuery.filters[filterName] = selectedValue;

        setQuery(newQuery);

    }

    const handleBack = () => {
        setSelectedGroup(null);

        var newQuery = JSON.parse(JSON.stringify(query));

        newQuery.filters["protocolIds"] = null;
        newQuery.filters["specialtyId"] = null;
        newQuery.filters["practitionerId"] = null;
        setProtocolId(null);
        
        setQuery(newQuery);
    };

  //#endregion

    if (isLoading)
        return <ModalSpinner isShowing={true} />;

    return (
        <div className="p-4">

            {!selectedGroup ?
                (
                    <Card
                        header={
                            <>
                                <Row>
                                    <Col md={2}>
                                        < CreateGroup onCreate={handleCreateGroup} />
                                    </Col>

                                    <Col md={2}>
                                        <ProtocolPicker
                                            id="protocol"
                                            name="protocolIds"
                                            multiple={false}
                                            placeholder={t("filters.protocol")}
                                            onChange={handleFilterChange}
                                        />
                                    </Col>

                                    <Col md={2}>
                                        <SnomedPicker
                                            id="specialties"
                                            name="specialtyId"
                                            placeholder={t("filters.speciality")}
                                            onChange={handleFilterChange}
                                            conceptId={snomedExpressions.Especialidades}
                                            multiple={false}
                                        />

                                    </Col>

                                    <Col md={2}>
                                        <PractitionerPicker
                                            id="practitioner"
                                            name="practitionerId"
                                            //autoFocus
                                            multiple={false}
                                            onlyDoctor={true}
                                            placeholder={t('protocols.brief.practitioner')}
                                            onChange={handleFilterChange}
                                        />
                                    </Col>                                                                   
                                </Row>
                            </>
                        }

                        content={
                            <>
                                <GroupListContainer
                                    groups={groups}
                                    onSelect={setSelectedGroup}
                                    isLoading={isLoadingGroups}
                                    editGroupButton={<EditGroup editGroup={handleEditGroup} />}
                                    duplicateGroupButton={<DuplicateGroup onCreate={handleCreateGroup} />}
                                />

                            </>
                        }
                    />

                ) :
                (
                    <GroupDetailContainer
                        group={selectedGroup}
                        onBack={handleBack}
                        updateGroup={handleUpdateGroup}
                        protocolId={{ protocolId }}
                    />
                )}
        </div>
    );
};

export default GroupsContainer;